/**
 * TreatmentExportPreview — on-screen "paper" rendering of the single-treatment
 * PDF. Shared blocks from components/pdfExport/PdfPaperBlocks.js; the Q&A body
 * mirrors functions/treatmentPdfHtmlTemplate.js (same class names).
 */

import {
  Paper,
  PaperLetterhead,
  PaperAddressee,
  PaperTitle,
  PaperPatientMeta,
  PaperChips,
  PaperEmpty,
  PaperSignature,
  PaperFootnote,
  PaperFooterStrip,
} from "../../pdfExport/PdfPaperBlocks";

function Answer({ block }) {
  if (block.empty) return <div className="qa-a empty">—</div>;
  if (block.value?.kind === "html") {
    return <div className="qa-a" dangerouslySetInnerHTML={{ __html: block.value.html }} />;
  }
  return <div className="qa-a">{block.value?.text}</div>;
}

function TreatmentExportPreview({ model }) {
  return (
    <Paper>
      <PaperLetterhead letterhead={model.letterhead} />
      <PaperAddressee text={model.addressee} />
      <PaperTitle text={model.title} />
      <PaperPatientMeta rows={model.patientRows} />
      <PaperChips chips={model.chips} />

      <main className="ck-form-doc">
        {!model.hasContent && (
          <PaperEmpty>אין תשובות להצגה בתיעוד זה (ייתכן שכל השדות ריקים והוסתרו).</PaperEmpty>
        )}
        {model.blocks.map((b) =>
          b.kind === "section" ? (
            <h2 className="qa-section" key={b.id}>
              {b.label}
            </h2>
          ) : (
            <div className="qa" key={b.id}>
              {b.label && <h3 className="qa-q">{b.label}</h3>}
              <Answer block={b} />
            </div>
          )
        )}

        {model.recommendations && (
          <section className="reco">
            <h2>המלצות</h2>
            <p>{model.recommendations}</p>
          </section>
        )}

        <PaperSignature signature={model.signature} />
      </main>

      <PaperFootnote text={model.footerNote} />
      <PaperFooterStrip />
    </Paper>
  );
}

export default TreatmentExportPreview;
